module.exports = __webpack_public_path__ + "static/media/tealSmiley.980fd385.png";